<template>
  <div class="kt-grid kt-grid--ver kt-grid--root">
    <div
      class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
      id="kt_login"
    >
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
      >
        <!--begin::Aside-->
        <div
          class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        >
          <div class="kt-grid__item">
            <a href="#" class="kt-login__logo">
              <img src="@/assets/media/logos/logo-mini-sm.png" />
            </a>
          </div>
          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
            <div class="kt-grid__item kt-grid__item--middle">
              <h3 class="kt-login__title">باشقۇرۇش مەركىزىگە خۇش كەپسىز!</h3>
              <h4 class="kt-login__subtitle">
                تور دۇنياسى قانون سىرتىدىكى دۇنيا ئەمەس، قانون بىلەن ئ‍ويناشماڭ، باشقۇرۇش سېستىمىسىغا قانونسىز بۆسۈپ كىرىش ئەھۋالى بىردەك جىنايى ئىشلار قانونى بويىچە بىر تەرەپ قىلىنىدۇ!
              </h4>
            </div>
          </div>
          <div class="kt-grid__item" v-if="false">
            <div class="kt-login__info">
              <div class="kt-login__copyright">
                © 2020 izchi
              </div>
              <div class="kt-login__menu">
                <p class="kt-login__copyright">ئىزچى تور پەن - تېخنىكا چەكلىك شىركىتى</p>
              </div>
            </div>
          </div>
        </div>
        <!--begin::Aside-->

        <!--begin::Content-->
        <div
          class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper"
        >
          <router-view></router-view>
        </div>
        <!--end::Content-->
      </div>
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
export default {
  name: "auth",
  methods: {},
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  }
};
</script>
